/**
 * Sidebar Resolution filter: binds RmaListFiltersStore resolution draft to
 * RmaListFilterControl via filterControlDataProps (grouped single-select radio list).
 */
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import RmaListFiltersStore from "../../../rma-list-page/stores/rma-list-filters-store";
import { RMA_LIST_FILTER_CONTROL_DATA_TYPE } from "../rma-list-filter-control/rma-list-filter-control-portal/rma-list-filter-control-content/rma-list-filter-control-content";
import RmaListFilterControl from "../rma-list-filter-control/rma-list-filter-control";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled?: boolean;
}

const RmaListFilterResolution: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const selectedId = rmaListFiltersStore.selectedResolutionId;

    return (
        <RmaListFilterControl
            label={getTranslation("RESOLUTIONS", scope)}
            selectedLabel={rmaListFiltersStore.selectedResolutionLabel}
            disabled={disabled}
            onOpen={() => rmsMixpanelStore.trackEvent("d&_filter_resolutions")}
            onClear={() => rmaListFiltersStore.setSelectedResolutionId(null)}
            filterControlDataProps={{
                type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.GROUPED_OPTIONS,
                value: selectedId,
                groups: rmaListFiltersStore.resolutionFilterGroups,
                onChange: (id) => {
                    rmaListFiltersStore.setSelectedResolutionId(Number(id));
                },
            }}
        />
    );
});

export default RmaListFilterResolution;
